export const filter = (obj: Record<string, string | number>) => {
  return Object.entries(obj)
    .map(([key, value], index) => `${index === 0 ? "?" : ""}${key}=${value}`)
    .join("&");
};
